import deepmerge from 'deepmerge';
import { buildModuleLoggerFunctions } from '../utils/log';
import { buildModuleTrackingFunction } from '../utils/tracking';
/** Build basic moduleProps (provide dedicated `log` and `track`) and copy over the `ModuleConfig.config` */
export function buildBasicModuleProps(moduleConfig) {
    return {
        config: moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.config,
        log: buildModuleLoggerFunctions(moduleConfig),
        track: buildModuleTrackingFunction(moduleConfig),
    };
}
/** Build moduleProps with extended properties along with dedicated `log` and `track` and `ModuleConfig.config`. */
export function buildModuleProps(config, additionalProps) {
    const basic = buildBasicModuleProps(config);
    if (additionalProps) {
        return deepmerge(basic, additionalProps !== null && additionalProps !== void 0 ? additionalProps : {});
    }
    return basic;
}
